import styled from 'styled-components';

import { IframeFullDoc } from 'modules/secureIframe';
import { caption, colors, fonts, fontSizes, fontWeights, letterSpacing, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const PreviewContentContainer = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: center;
  padding: ${spacing.plusHalf};
  position: relative;
`;

export const PreviewContent = styled.div<{ isDesktop: boolean }>`
  border-radius: ${pxToRem(12)};
  border: ${spacing.eighth} solid ${colors.grey25};
  display: flex;
  flex-direction: column;
  height: ${({ isDesktop }) => (isDesktop ? `auto` : pxToRem(600))};
  letter-spacing: ${letterSpacing.pos10};
  min-height: ${pxToRem(600)};
  overflow: hidden;
  position: relative;
  width: ${({ isDesktop }) => (isDesktop ? `100%` : pxToRem(320))};
`;

export const PreviewContentBody = styled.div<{ isDesktop: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

export const PreviewFrame = styled(IframeFullDoc)`
  overflow-x: auto;
  width: 100%;
`;

export const PreviewContentBodyEmpty = styled.div`
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  padding: ${spacing.plusHalf};
`;

export const PreviewContentBodyEmptyMsg = styled.div`
  ${caption};
  color: ${colors.textSecondary};
  max-width: ${pxToRem(220)};
  text-align: center;
`;

export const EmailHeaderContainer = styled.div`
  align-items: stretch;
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  font-family: ${fonts.sansSerif};
  padding: ${spacing.plusHalf} ${spacing.plusQuarter};
`;

export const EmailHeaderSubject = styled.div`
  color: ${colors.textPrimary};
  font-size: ${fontSizes.s16};
  font-weight: ${fontWeights.semiBold};
  line-height: ${fontSizes.s20};
`;

export const EmailHeaderPreheader = styled.div`
  color: ${colors.textPrimary};
  font-size: ${fontSizes.s14};
  line-height: ${fontSizes.s20};
  margin-top: ${pxToRem(10)};
  word-break: break-all;
`;

export const EmailHeaderAddress = styled.div`
  display: flex;
  font-size: ${fontSizes.s12};
  line-height: ${fontSizes.s16};
  letter-spacing: ${letterSpacing.pos10};
  flex-direction: column;
  margin-top: ${pxToRem(10)};
`;

export const EmailHeaderAddressFrom = styled.div`
  color: ${colors.textPrimary};
  white-space: break-spaces;
  word-break: break-word;
`;

export const EmailHeaderAddressTo = styled.div`
  color: ${colors.textSecondary};
`;
